// npm packages
import classNames from "classnames";

// components
import Icon from "../Icon";
import Text from "../Text";

// utils

const GoBackSmall = ({
  className = "",
  onClick= () => {},
  disabled = false,
}) => {

  return (
    <button
      className={classNames("flex items-center gap-1.5 pt-20 cursor-pointer", className)}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon
        type="arrow-left"
        color={"#49525E"}
        className="size-[24px]"
      />
      <Text
        type="paragraph"
        className="!text-16 text-senate font-semibold leading-20 tracking-[0.32px]"
      >
        Go Back
      </Text>
    </button>
  );
};

export default GoBackSmall;
